var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "86d270c2-4c29-4355-9848-2ff438f0755b"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "1d22f79f-ac93-4dde-8949-0b2ccda17b7b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "9e704db1-49f4-4329-b7c6-3b35e0539630"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(38,185,219)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(238,239,241)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-481.5, -44.37)",
    d: "M 2 86.9998 C 52.6667 22.6664 187.4 -67.4002 321 86.9998 C 374.333 26.9997 512.8 -57.0004 640 86.9998 C 700.333 28.6664 849 -53.0004 961 86.9998",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(NaN NaN NaN NaN 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessLine);
export default __webpack_public_path__ + "static/media/process_line.2faf2c0529be18de27792e02a2f51591.svg";
export { ForwardRef as ReactComponent };